// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-end {
  border-end-end-radius: 50px;
  border-start-end-radius: 50px;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}

.icon2 {
  width: 1rem;
}

.game-bar {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
  min-width: 20rem;
  height: 2.5rem;
  background: var(--color-light-blue);
  border-radius: 5rem;
}
.game-bar .btn-group {
  background: var(--color-light-blue);
  width: 100%;
  border: none;
  color: var(--color-primary-blue);
  height: 2.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
}

.flex-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.flex-container .gm-flex-col {
  flex: auto;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  position: relative;
}
.flex-container .gm-flex-col .gm-flex-75 {
  flex: 75%;
}
.flex-container .gm-flex-col .gm-flex-50 {
  flex: 50%;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .gm-flex-25 {
  flex: 25%;
}
.flex-container .gm-flex-col .iconBold {
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconHand {
  margin: 0;
  width: 1.542rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconStar {
  width: 1.208rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconFlag {
  width: 1.333rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .icon {
  width: 1rem;
}
.flex-container .gm-flex-col .prev-action-points {
  position: absolute;
  right: 16%;
  font-size: 0.667rem;
  color: var(--color-white);
  display: none;
  background-color: var(--color-secondary-blue);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-alliance-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-white);
  display: none;
  background-color: var(--color-secondary-blue);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-council-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  display: none;
  background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-country-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  display: none;
  background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .fs-28 {
  font-size: 1.167rem;
}
.flex-container .gm-flex-col .fs-24 {
  font-size: 1rem;
}
.flex-container .gm-flex-col .fs-20 {
  font-size: 0.833rem;
}
.flex-container .gm-flex-col:not(:last-child) {
  border-right: 0.125rem solid rgba(51, 102, 153, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/app/game/game-bar/game-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,6BAAA;AACF;;AAEA;EACE,6BAAA;EACA,+BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;AACF;AACE;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AACJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAFF;AAIE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AAFJ;AAKI;EACE,SAAA;AAHN;AAMI;EACE,SAAA;EACA,aAAA;EACA,uBAAA;AAJN;AAOI;EACE,SAAA;AALN;AAQI;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AANN;AASI;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAPN;AAUI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AARN;AAWI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AATN;AAYI;EACE,WAAA;AAVN;AAaI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAXN;AAcI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAZN;AAeI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAbN;AAgBI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAdN;AAiBI;EACE,mBAAA;AAfN;AAkBI;EACE,eAAA;AAhBN;AAmBI;EACE,mBAAA;AAjBN;AAqBE;EACE,qDAAA;AAnBJ","sourcesContent":[".button-end {\n  border-end-end-radius: 50px;\n  border-start-end-radius: 50px;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n\n.icon2 {\n  width: 1rem;\n}\n\n.game-bar {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  z-index: 2;\n  min-width: 20rem;\n  height: 2.5rem;\n  background: var(--color-light-blue);\n  border-radius: 5rem;\n\n  .btn-group {\n    background: var(--color-light-blue);\n    width: 100%;\n    border: none;\n    color: var(--color-primary-blue);\n    height: 2.5rem;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 1rem;\n    cursor: pointer;\n    padding: 0;\n  }\n}\n\n\n\n.flex-container {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n\n  .gm-flex-col {\n    flex: auto;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    padding-left: 0.3rem;\n    padding-right: 0.3rem;\n    position: relative;\n    //cursor: pointer;\n\n    .gm-flex-75 {\n      flex: 75%;\n    }\n\n    .gm-flex-50 {\n      flex: 50%;\n      display: flex;\n      justify-content: center;\n    }\n\n    .gm-flex-25 {\n      flex: 25%;\n    }\n\n    .iconBold {\n      margin-left: 0.5rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconHand {\n      margin: 0;\n      width: 1.542rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconStar {\n      width: 1.208rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconFlag {\n      width: 1.333rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .icon {\n      width: 1rem;\n    }\n\n    .prev-action-points {\n      position: absolute;\n      right: 16%;\n      font-size: 0.667rem;\n      color: var(--color-white);\n      display: none;\n      background-color: var(--color-secondary-blue);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-alliance-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-white);\n      display: none;\n      background-color: var(--color-secondary-blue);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-council-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-primary-blue);\n      display: none;\n      background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-country-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-primary-blue);\n      display: none;\n      background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .fs-28 {\n      font-size: 1.167rem;\n    }\n  \n    .fs-24 {\n      font-size: 1rem;\n    }\n\n    .fs-20 {\n      font-size: 0.833rem;\n    }\n  }\n\n  .gm-flex-col:not(:last-child) {\n    border-right: 0.125rem solid rgba(51, 102, 153, 0.25);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
